module.exports = __webpack_public_path__ + "img/news-icon.a664f0c0.svg";